import { render } from "./ComponentView.vue?vue&type=template&id=481fff7e"
import script from "./ComponentView.vue?vue&type=script&lang=js"
export * from "./ComponentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__